import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "copyFilled"
const CopyFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M19.875 6.375C20.703 6.375 21.375 7.047 21.375 7.875V19.875C21.375 20.703 20.703 21.375 19.875 21.375H7.875C7.047 21.375 6.375 20.703 6.375 19.875V7.875C6.375 7.047 7.047 6.375 7.875 6.375zM3.75 15.75H4.875V17.25H3.75C2.922 17.25 2.25 16.578 2.25 15.75V14.035H3.75zM3.75 11.465H2.25V8.035H3.75zM5.465 3.75H3.75V5.465H2.25V3.75C2.25 2.922 2.922 2.25 3.75 2.25H5.465zM15.75 2.25C16.578 2.25 17.25 2.922 17.25 3.75V4.875H15.75V3.75H14.035V2.25zM11.465 3.75H8.035V2.25H11.465z" />
        </svg>
      }
    </span>
  )
}
export default CopyFilledIcon
